// code reference : https://codesandbox.io/p/sandbox/material-ui-nested-menu-item-example-forked-xwr8v?file=%2Fsrc%2FNestedMenu%2FNestedMenu.tsx%3A131%2C13

import NestedMenu, { NestedMenuProps } from "./NestedMenu";
import { NestedMenuContextProvider } from "./NestedMenuContext";

export default (props: NestedMenuProps) => {
  return (
    <NestedMenuContextProvider {...props}>
      <NestedMenu {...props} />
    </NestedMenuContextProvider>
  );
};
